export const ChevronDoubleRight = ({ size = 24 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3523 18.8486C11.8836 18.3799 11.8836 17.6202 12.3523 17.1515L17.5037 12L12.3523 6.84858C11.8836 6.37995 11.8836 5.62015 12.3523 5.15152C12.8209 4.68289 13.5807 4.68289 14.0493 5.15152L20.0493 11.1515C20.5179 11.6202 20.5179 12.3799 20.0493 12.8486L14.0493 18.8486C13.5807 19.3172 12.8209 19.3172 12.3523 18.8486Z"
        fill="#4FC0CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.15225 18.8486C4.68362 18.3799 4.68362 17.6202 5.15225 17.1515L10.3037 12L5.15225 6.84858C4.68362 6.37995 4.68362 5.62015 5.15225 5.15152C5.62088 4.68289 6.38068 4.68289 6.84931 5.15152L12.8493 11.1515C13.3179 11.6202 13.3179 12.3799 12.8493 12.8486L6.84931 18.8486C6.38068 19.3172 5.62088 19.3172 5.15225 18.8486Z"
        fill="#4FC0CF"
      />
    </svg>
  );
};
